export default __webpack_public_path__ + "static/media/Working Platforms.55c127f6.jpg";